import React, { Component } from 'react';
import ApiService from '../services/apiService';
import L from '../services/localizationService';
import CurrencyInput from './currencyinput';

import { CircularProgress } from '@rmwc/circular-progress';
import { DataTable, DataTableContent, DataTableHead, DataTableRow, DataTableHeadCell, DataTableCell, DataTableBody } from '@rmwc/data-table';
import { Dialog, DialogActions, DialogButton, DialogContent, DialogTitle } from '@rmwc/dialog';
import { Icon } from '@rmwc/icon';

class CostCodeSeriesDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      projNum: props.project,
      estimatedFinalCostDialogOpen: props.estimatedFinalCostDialogOpen,
      projectCostCodeTotals: props.projectCostCodeTotals,
      onClose: props.onClose,
      onSaved: props.onSaved,
      isSaving: false,

      costCodes: null,
      newItemsCounter: 0,
      newItems: [],
      deletes: [],

      dialogCounter: 0,
    }

    this.state.projectTaskTens = this.translateEstimatedFinalCostItems(props.projectTaskTens);
  }

  translateEstimatedFinalCostItems(theProjectTaskTens) {
    let projectTaskTens = [];
    if (theProjectTaskTens) {
      theProjectTaskTens.forEach((item) => {
        let itemCopy = Object.assign({}, item);
        itemCopy.EstimatedFinalCost = L.truncateDecimals(item.EstimatedFinalCost || '0.00');
        projectTaskTens.push(itemCopy);
      })
    }

    return projectTaskTens;
  }

  resetComponent(newProjectTaskTens, newProjectCostTotals) {
    this.setState({
      projectTaskTens : this.translateEstimatedFinalCostItems(newProjectTaskTens),
      projectCostCodeTotals: newProjectCostTotals,
      newItemsCounter: 0,
      newItems: [],
      deletes: [],
      isSaving: false,
      dialogCounter: this.state.dialogCounter+1
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.projectTaskTens !== prevProps.projectTaskTens || this.props.projectCostCodeTotals !== prevProps.projectCostCodeTotals) {
      this.resetComponent(this.props.projectTaskTens, this.props.projectCostCodeTotals);
    }
  }

  saveItems() {
    let updateCostCodes = [];
    let updates = this.state.projectTaskTens.map((item) => {
      if (!this.state.deletes.includes(item._ItemId) && !isNaN(parseFloat(item.EstimatedFinalCost))) {
        updateCostCodes.push(item.CostCode);
        return { _ItemId: item._ItemId, amount: item.EstimatedFinalCost};
      }
      else {
        console.error('Invalid save item detected: ', item)
        return null;
      }
    });

    /* Apr 14 2020 - This is the full sequence below, but we're only interested
    in updated items for now...

    let inserts = this.state.newItems.map((item) => {
      if (!updateCostCodes.includes(item.costCode) && item.CostCode && !isNaN(parseFloat(item.amount) !== NaN)) {
        return { _ItemId: item.newItemId, costCode: item.costCode, amount: item.amount};
      }
    });

    let deletes = this.state.deletes.map((item) => {
      return { _ItemId: item };
    });

    ApiService.deleteEstimatedFinalCostItems(deletes)
      .then(() => {
        return ApiService.updateEstimatedFinalCostItems(updates);
      })
      .catch(() => {
        return ApiService.updateEstimatedFinalCostItems(updates);
      })
      .then(() => {
        return ApiService.insertEstimatedFinalCostItems(this.props.projNum, inserts);
      })
      .then(() => {
        return ApiService.invokeProjectTaskBudgetRollup(this.props.projNum);
      })
      .finally(() => {
        console.debug('Series items queries completed');
        if (this.props.onSaved) {
          this.props.onSaved();
        }
      })
      */
    ApiService.updateEstimatedFinalCostItems(updates)
      .then(() => {
        return ApiService.invokeProjectTaskBudgetRollup(this.props.projNum);
      })
      .catch((err) => {
        console.error('Saving cost code series failed', err);
        window.alert(typeof err === 'string' ? err : 'Saving the cost code series failed. See the browser console for details.');
      })
      .finally(() => {
          console.debug('Series items queries completed');
          if (this.props.onSaved) {
            this.props.onSaved();
          }
        })
  }

  removeExistingCodeCode(itemId) {
    this.setState({ deletes: [...this.state.deletes, itemId]});
  }

  removeNewItemRow(id) {
    let newItemsArray = [];
    this.state.newItems.forEach((item) => {
      if (item.newItemId !== id) {
        newItemsArray.push(item);
      }
    })

    this.setState({ newItems: newItemsArray })
  }

  handleLineItemEdit(id, amount, costCode) {
    this.setState({
      newItems: this.state.newItems.map(el => {
        if (el.newItemId === id) {
          let updatedItem = Object.assign({}, el, { amount, costCode });
          this.updateNewItemRow(updatedItem);
          return updatedItem; 
        }
        else {
          return el;
        }
      })
    });
}

getCostCodeSelectorItems() {
  let costCodeSelectorItems = [<option value="">-</option>];
  if (this.props.costCodes) {
    this.props.costCodes.forEach((element) => {
      // Only display cost codes in this series & ones that aren't already selected
      if (L.costCodeToIndex(element.cost_code) === this.props.seriesCodeIdx) {
        costCodeSelectorItems.push(<option key={element.cost_code} value={element.cost_code}>{`${element.cost_code}`}</option>);
      }
  })
}
 return costCodeSelectorItems;
}

updateNewItemRow(newItemData) {
  let costCodeSelectorItems = this.getCostCodeSelectorItems();
  let description = '';

  if (newItemData.costCode) {
    let foundItem = this.state.projectTaskTens.find((item) => item.CostCode === newItemData.costCode);
    if (foundItem) {
      description = foundItem.WMS_DerCostCodeDescription;
    }
  }

  newItemData.row = 
    <DataTableRow key={`newitemrow_${newItemData.newItemId}`}>
      <DataTableCell>
        <select value={newItemData.costCode}
          onChange={(e) => { this.handleLineItemEdit(newItemData.newItemId, newItemData.amount, e.target.value); }}>        
          {costCodeSelectorItems}
        </select>
      </DataTableCell>
      <DataTableCell>{description}</DataTableCell>
      <DataTableCell>
        <input value={newItemData.amount}
          onChange={(e) => { this.handleLineItemEdit(newItemData.newItemId, e.target.value, newItemData.costCode); }} /></DataTableCell>
      <DataTableCell><Icon icon="delete" onClick={() => { this.removeNewItemRow(newItemData.newItemId); }}/></DataTableCell>
    </DataTableRow>;
}

  addNewItemRow() {
    let newId = this.state.newItemsCounter + 1;

    let newItemData = {
      newItemId: newId,
      costCode: '',
      amount: '',
      row: null
    };

    this.updateNewItemRow(newItemData);

    this.setState({
      newItemsCounter: newId,
      newItems: [...this.state.newItems, newItemData]
    });
  }

  render() {
    let saveIcon = null; 
    let buttonsDisabled = false;

    if (this.state.isSaving) {
      saveIcon = <CircularProgress/>; 
      buttonsDisabled = true;
    }

    let tableBody = [];
    let hasDuplicates = false;
    let columnTotals = {
      revisedEt: 0,
      totalCommitted: 0,
      estimatedFinalCost: 0,
    }

    if (this.state.projectTaskTens) {
      this.state.projectTaskTens.forEach((item, idx) => {

        let totalCommittedTotalObj = this.state.projectCostCodeTotals.find(totalsItem => totalsItem.CostCode === item.CostCode);
        let totalCommittedTotal = totalCommittedTotalObj !== undefined ? totalCommittedTotalObj.totalCommitted : '';
        let totalRevisedEtTotal = totalCommittedTotalObj !== undefined ? totalCommittedTotalObj.totalRevisedEt : '';
        let isDuplicate = totalCommittedTotalObj !== undefined && totalCommittedTotalObj.rowCount > 1;
        if (isDuplicate) hasDuplicates = true;

        columnTotals.revisedEt += L.parseFloatWithZero(totalRevisedEtTotal)
        columnTotals.totalCommitted += L.parseFloatWithZero(totalCommittedTotal)
        columnTotals.estimatedFinalCost += L.parseFloatWithZero(item.EstimatedFinalCost)


        if (!this.state.deletes.includes(item._ItemId)) {
          let warningIcon = isDuplicate ?
            <Icon icon="warning" style={{color: 'orange', fontSize: '16px', marginLeft: '4px', verticalAlign: 'middle', cursor: 'pointer'}}
              title={`${totalCommittedTotalObj.rowCount} line items summed for this cost code`} /> : null;

          tableBody.push(
            <DataTableRow key={item.CostCode}>
                <DataTableCell>{item.CostCode}{warningIcon}</DataTableCell>
                <DataTableCell>{item.WMS_DerCostCodeDescription}</DataTableCell>
                <DataTableCell>{L.toCurrencyString(totalRevisedEtTotal)}</DataTableCell>
                <DataTableCell>{L.toCurrencyString(totalCommittedTotal)}</DataTableCell>
                <DataTableCell>
                  <CurrencyInput id={item.CodeCode} value={item.EstimatedFinalCost}
                    onChanged={(newValue) => { item.EstimatedFinalCost = newValue; this.setState({'test': true})}} />
                </DataTableCell>
                { /* Removed Apr 14 2020 - not required yet
                <DataTableCell><Icon style={{cursor: 'pointer'}} icon="delete" onClick={() => this.removeExistingCodeCode(item._ItemId)} /></DataTableCell>
                */}
            </DataTableRow>
          )
        }
      })

      tableBody.push(
        <DataTableRow style={{fontWeight: 'bold'}} key="totals">
            <DataTableCell></DataTableCell>
            <DataTableCell></DataTableCell>
            <DataTableCell>{L.toCurrencyString(columnTotals.revisedEt)}</DataTableCell>
            <DataTableCell>{L.toCurrencyString(columnTotals.totalCommitted)}</DataTableCell>
            <DataTableCell>{L.toCurrencyString(columnTotals.estimatedFinalCost)}</DataTableCell>
        </DataTableRow>
      )
}

    let noItems = null;
    if (this.state.projectTaskTens.length === 0) {
      noItems=<div style={{textAlign: 'center', fontWeight: 'bold', width: '100%'}}>No Items</div>
    }

    let dialogKey = `costCodeDialog_${this.state.dialogCounter}`;
    return <Dialog key={dialogKey} id={dialogKey} preventOutsideDismiss open={this.props.open} onClose={evt => {
        if (this.state.onClose) this.state.onClose(evt.detail.action === 'save');
      }} >
        <DialogTitle>{this.props.seriesCodeIdx}00 Series</DialogTitle>
        <DialogContent className="costCodeSeriesDialog-table">
          {hasDuplicates &&
            <div style={{padding: '8px 12px', marginBottom: '8px', backgroundColor: '#fff3e0', borderRadius: '4px', display: 'flex', alignItems: 'center'}}>
              <Icon icon="warning" style={{color: 'orange', marginRight: '8px'}} />
              <span>Some cost codes have multiple line items that have been summed. Hover over the
                {' '}<Icon icon="warning" style={{color: 'orange', fontSize: '16px', verticalAlign: 'middle'}} />{' '}
                icon for details. See the{' '}
                <a href="#" style={{color: '#1565c0'}} onClick={(e) => { e.preventDefault(); if (this.props.onLaunchCostDetailReport) this.props.onLaunchCostDetailReport(); }}>
                  Project Cost Detail Report
                </a> in SyteLine for the full breakdown.
              </span>
            </div>
          }
          <DataTable>
            <DataTableContent>
              <DataTableHead>
                <DataTableRow key="series_datatable_header">
                  <DataTableHeadCell className="costcode" alignMiddle>Cost<br/>Code</DataTableHeadCell>
                  <DataTableHeadCell alignMiddle>Description</DataTableHeadCell>
                  <DataTableHeadCell className="six-digit" alignMiddle>Revised<br/>ET</DataTableHeadCell>
                  <DataTableHeadCell className="six-digit" alignMiddle>Total<br/>Committed</DataTableHeadCell>
                  <DataTableHeadCell className="amount" alignMiddle>Estimated<br />Final Cost</DataTableHeadCell>
                  { /* Removed Apr 14 2020 - not required yet
                  <DataTableHeadCell className="delete"></DataTableHeadCell>
                  */ }
                </DataTableRow>
              </DataTableHead>

              <DataTableBody className="no-hover">

                {tableBody}

                {this.state.newItems.map((item) => { return item.row; })}
                
                { /* Removed Apr 14 2020 - not required yet
                <DataTableRow key="newcodeholder">
                  <DataTableCell colSpan="4" alignMiddle><Button raised icon="add_circle" onClick={() => {this.addNewItemRow();}}>Add Item</Button></DataTableCell>
                </DataTableRow>
                */ }

              </DataTableBody>
            </DataTableContent>
          </DataTable>
        </DialogContent>

        {noItems}
        
        <DialogActions>
          <DialogButton disabled={buttonsDisabled} icon={saveIcon} action="save" onClick={() => { this.setState({isSaving : true}); this.saveItems()}}>Save</DialogButton>
          <DialogButton disabled={buttonsDisabled} action="cancel">Cancel</DialogButton>
        </DialogActions>
      </Dialog>
    
  }
}

export default CostCodeSeriesDialog;
